

































import { defineComponent, PropType } from '@vue/composition-api';
import { useI18N } from '@a/composables/use-vue-i18n';
import { CloudUnitType } from '@a/store/product/types';
import { ProductExtension } from '@a/store/landingpage/types';

export default defineComponent({
  name: 'OrderWidgetBoxSlots',
  props: {
    /**
     * days of duration
     */
    duration: {
      type: Number,
      required: true,
    },
    /**
     * stands for the actual units of the OW
     */
    slots: {
      type: Number,
      required: true,
    },
    /**
     * formatted price of the OW
     */
    formattedPrice: {
      type: String,
      required: true,
    },
    /**
     * unit type of the product (e.x. RAM)
     */
    cloudUnitType: {
      type: Object as PropType<CloudUnitType>,
      required: true,
    },
    /**
     * stands for the extension linked to the order configuration
     */
    extras: {
      type: Array as PropType<Array<ProductExtension>>,
      required: false,
      default: () => [],
    },
  },
  setup() {
    const i18n = useI18N();

    return {
      i18n,
    };
  },
});
